<template>
  <div id="app">
    <section>
      <div class="page-title">常见问题<div style="height: 8px"></div></div>
      <div class="page-title1">
      <router-link to="/nobind" class="mint-cell"><span class="mint-cell-mask"></span>
        <div class="mint-cell-left"></div>
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title">
            <!---->
            <div><i class="indexicon icon-toast"></i> <span>绑定不上</span></div>
          </div>
          <div class="mint-cell-value is-link"><span></span></div> <i class="mint-cell-allow-right"></i>
        </div>
        <div class="mint-cell-right"></div>
      </router-link>
      </div >
      <div class="page-title1">
        <router-link to="/nobindmsg" class="mint-cell"><span class="mint-cell-mask"></span>
        <div class="mint-cell-left"></div>
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title">
            <!---->
            <div><i class="indexicon icon-toast"></i> <span>报警消息推送时手机不响或接收不到</span></div>
          </div>
          <div class="mint-cell-value is-link"><span></span></div> <i class="mint-cell-allow-right"></i>
        </div>
        <div class="mint-cell-right"></div>
        </router-link>
      </div>
      <div class="page-title1">
        <router-link to="/brightscreentime" class="mint-cell"><span class="mint-cell-mask"></span>
          <div class="mint-cell-left"></div>
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
              <!---->
              <div><i class="indexicon icon-toast"></i> <span>亮屏时间无法设置</span></div>
            </div>
            <div class="mint-cell-value is-link"><span></span></div> <i class="mint-cell-allow-right"></i>
          </div>
          <div class="mint-cell-right"></div>
        </router-link>
      </div>
      <div class="page-title1">
        <router-link to="/appopen" class="mint-cell"><span class="mint-cell-mask"></span>
          <div class="mint-cell-left"></div>
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
              <!---->
              <div><i class="indexicon icon-toast"></i> <span>APP远程开锁</span></div>
            </div>
            <div class="mint-cell-value is-link"><span></span></div> <i class="mint-cell-allow-right"></i>
          </div>
          <div class="mint-cell-right"></div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'common_problem'
  }
</script>

<style scoped>
  .indexicon {
    font-size: 22px;
    color: #26a2ff;
    display: inline-block;
    width: 30px;
    vertical-align: middle;
  }
  .page-title {
    font-weight:900;
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;

    border-style: solid;
    border-color: #F5F5F5;
  }
  .page-title1 {
    font-weight:100;

    line-height: 25px;
    font-family:blod 黑体;
        font-size: 18px;
        margin: 20px auto;
        line-height: 1;
        left: 14px;
        border-width: 0 0 0 0;

        border-style: solid;
      }
  .indexicon {
    font-size: 22px;
    color: #26a2ff;
    display: inline-block;
    width: 30px;
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// src/components/commonproblem/commonproblem.vue